import { createRouter, createWebHashHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import type { App } from 'vue'
import { Layout, getParentLayout } from '@/utils/routerHelper'
import { useI18n } from '@/hooks/web/useI18n'
import { stringifyQuery, parseQuery } from '@/utils/queryEncrypt'
import { helpRouterMap } from './helpRouter'
// import Mid from '@/views/Mid/index.vue'

const { t } = useI18n()
const AdminRoute: any = []
export const constantRouterMap: AppRouteRecordRaw[] = [
  {
    path: '/',
    component: Layout,
    name: 'Root',
    redirect: '/home/index',
    meta: {
      hidden: true
    }
  },
  {
    path: '/home',
    component: Layout,
    redirect: '/home/index',
    name: 'HomeList',
    meta: {
      title: '首页',
      icon: 'icon-homepage'
    },
    children: [
      {
        name: 'Home',
        meta: { title: '首页', hidden: true },
        path: 'index',
        component: () => import('@/views/Home/index.vue')
      }
    ]
  },
  {
    path: '/mid',
    component: () => import('@/views/Mid/index.vue'),
    name: 'Mid',
    meta: {
      hidden: true,
      noTagsView: true
    }
  },
  {
    path: '/redirect',
    component: Layout,
    name: 'Redirect',
    children: [
      {
        path: '/redirect/:path(.*)',
        name: 'Redirect',
        component: () => import('@/views/Redirect/Redirect.vue'),
        meta: {}
      }
    ],
    meta: {
      hidden: true,
      noTagsView: true
    }
  },
  {
    path: '/login',
    component: () => import('@/views/Login/Login.vue'),
    name: 'Login',
    meta: {
      hidden: true,
      title: t('common.login'),
      noTagsView: true
    }
  },
  {
    path: '/logRole001',
    component: () => import('@/views/OperationAudit/LogRole001.vue'),
    name: 'Role001',
    meta: {
      hidden: true,
      title: t('platform.audit.logs.role'),
      noTagsView: true
    }
  },
  {
    path: '/logRole002',
    component: () => import('@/views/OperationAudit/LogRole002.vue'),
    name: 'Role002',
    meta: {
      hidden: true,
      title: t('platform.audit.logs.role'),
      noTagsView: true
    }
  },
  {
    path: '/logRole003',
    component: () => import('@/views/OperationAudit/LogRole003.vue'),
    name: 'Role003',
    meta: {
      hidden: true,
      title: t('platform.audit.logs.role'),
      noTagsView: true
    }
  },
  {
    path: '/logRole004',
    component: () => import('@/views/OperationAudit/LogRole004.vue'),
    name: 'Role004',
    meta: {
      hidden: true,
      title: t('platform.audit.logs.role'),
      noTagsView: true
    }
  },
  ...helpRouterMap,
  {
    path: '/404',
    component: Layout,
    name: '404',
    meta: {
      hidden: true,
      title: '404',
      noTagsView: true
    },
    children: [
      {
        path: '',
        name: 'AccessDenied',
        component: () => import('@/views/Error/AccessDenied.vue'),
        meta: {
          hidden: true,
          title: '暂无权限',
          noTagsView: true
        }
      },
      {
        path: 'account-denied',
        name: 'AccountDenied',
        component: () => import('@/views/Error/AccountDenied.vue'),
        meta: {
          hidden: true,
          title: '账号无权限',
          noTagsView: true
        }
      }
    ]
  },
  {
    path: '/document',
    name: 'document',
    component: () => import('@/views/Document/index.vue'),
    meta: {
      hidden: true,
      title: '文档',
      noTagsView: true
    }
  }
]

export const asyncRouterMap: AppRouteRecordRaw[] = [
  {
    path: '/cockpit-home',
    component: () => import('@/views/CockpitHome/index.vue'),
    name: 'CockpitHome',
    meta: {
      title: '驾驶舱',
      icon: 'icon-mingchengzhushuju'
    }
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  strict: true,
  routes: constantRouterMap as RouteRecordRaw[],
  scrollBehavior: () => ({ left: 0, top: 0 }),
  stringifyQuery,
  parseQuery
})

export const resetRouter = (): void => {
  const resetWhiteNameList = [
    '404',
    'AccessDenied',
    'AccountDenied',
    'Redirect',
    'Login',
    'NoFind',
    'Root'
  ]
  router.getRoutes().forEach((route) => {
    const { name } = route
    if (name && !resetWhiteNameList.includes(name as string)) {
      router.hasRoute(name) && router.removeRoute(name)
    }
  })
}

export const setupRouter = (app: App<Element>) => {
  app.use(router)
}

export default router

export const homeRoute = {
  permissionCode: 'BIR999998',
  orderBy: 0,
  name: 'HomeList',
  component: Layout,
  meta: { title: '首页', icon: 'icon-homepage' },
  level: 1,
  isButton: 0,
  path: '/home',
  redirect: '/home/index',
  state: 1,
  resourceCode: '',
  parentPermissionCode: '11004',
  children: [
    {
      permissionCode: 'BIR999999',
      orderBy: 1,
      name: 'Home',
      component: () => import('@/views/Home/index.vue'),
      meta: { title: '首页', resourceCode: 'BIR999999', button: [] },
      level: 2,
      isButton: 0,
      path: 'index',
      redirect: null,
      state: 1,
      resourceCode: '',
      parentPermissionCode: 'BIR999998',
      children: null,
      button: [],
      hidden: true,
      alwaysShow: null,
      selected: false,
      hasRoleDataPermissionInPage: false,
      canConfigRoleDataPermission: false
    }
  ]
}

export const colaPageRoute = {
  permissionCode: 'BIR999998',
  orderBy: 0,
  name: 'ColaPageList',
  component: Layout,
  meta: { title: '低代码页', icon: 'icon-homepage' },
  level: 1,
  isButton: 0,
  path: '/colaPage',
  redirect: '/colaPage/index',
  state: 1,
  resourceCode: '',
  parentPermissionCode: '11004',
  children: [
    {
      permissionCode: 'BIR999998',
      orderBy: 1,
      name: 'ColaPage',
      component: () => import('@/views/ColaPage/index.vue'),
      meta: { title: '低代码页', resourceCode: 'BIR999998', button: [] },
      level: 2,
      isButton: 0,
      path: 'index',
      redirect: null,
      state: 1,
      resourceCode: '',
      parentPermissionCode: 'BIR999998',
      children: null,
      button: [],
      hidden: true,
      alwaysShow: null,
      selected: false,
      hasRoleDataPermissionInPage: false,
      canConfigRoleDataPermission: false
    }
  ]
}
